module.exports = __webpack_public_path__ + "static/media/bg black copy.bded18f6.svg";